import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const PoliticAndTerroris = ({ refPoliticalExposedHuman }) => {
  const data = useLocation();
  const [politicAndTerroris, setPoliticAndTerroris] = useState({
    politicalExposed:
      data.state.data.PoliticalInformation.politicallyExposed || "",
  });
  return (
    <div className="section">
      <div className="tittleupdatebox">
        <p className="tittleupdate-amebo">
          Información Política y Verificación de Terrorismo
        </p>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate">
            Es políticamente expuesto:
          </label>
          <select
            ref={refPoliticalExposedHuman}
            className="inputupdate"
            defaultValue={politicAndTerroris.politicalExposed}
            onChange={(e) =>
              setPoliticAndTerroris({
                ...politicAndTerroris,
                politicalExposed: e.target.value,
              })
            }
          >
            <option value="No">No</option>
            <option value="Si">Si</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default PoliticAndTerroris;
